import { Input, InputElement } from "../../../../common/components";
import { GetInputOptions } from "../getInput";
import React from "react";
import getTranslatedValue from "../../../../utils/CustomerTranslations/getTranslatedValue";
export const getCheckboxInput = ({
  error,
  onChange,
  question,
  value,
  tCustomer
}: GetInputOptions) => {
  const {
    name,
    required
  } = question;
  const id = question.id ?? name;
  const label = getTranslatedValue(`customQuestion.${id}`, "name", tCustomer, question);

  // Shouldn't be possible, but just in case of bad data and mostly for TS
  if (typeof value !== "boolean" && typeof value !== "undefined") throw new Error(`Type mismatch on value of question ${id}. Expected boolean, received string.`);
  const onCheck = (event: React.ChangeEvent<InputElement>) => {
    onChange({
      id,
      newValue: !!event.target.value !== value
    });
  };
  return <Input variant="checkbox" id={id} label={label} error={error} checked={value ?? false} onChange={onCheck} required={required} data-sentry-element="Input" data-sentry-component="getCheckboxInput" data-sentry-source-file="getCheckboxInput.tsx" />;
};